import storageSession from 'redux-persist/lib/storage/session';

import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'sihosp',
      storage: storageSession,
      whitelist: ['auth', 'careLines', 'instituitions', 'users'],
    },
    reducers
  );

  return persistedReducer;
};
